import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import MC_OPEN from './mc_front_empty.svg';
import MC_CLOSED from './mc_front_closed.svg';

export function MicroImage(props) {
  const getImage = () => (props.isOpen ? MC_OPEN : MC_CLOSED);

  const onClick = (event) => {
    event.stopPropagation();
    props.onSelect(!props.isOpen);
  };

  return (
    <div className='microcentrifuge__image' onClick={onClick}>
      <Image style={{cursor: 'pointer'}} src={getImage()} alt='microcentrifuge_image' />
    </div>
  );
}

MicroImage.propTypes = {
  /**
   * Boolean to set if apparatus is open/closed
   */
  isOpen: PropTypes.bool,
  /**
   * function to invoke when Image is clicked
   */
  onSelect: PropTypes.func,
};

MicroImage.defaultProps = {};
